import BaseComponent from "@js/components/base_component.jsx";

class EuiSearchBox extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            q: props.defaultValue || "",
        };
    }

    render() {
        return (
            <form method="GET" onSubmit={ this._onSubmit }>
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={ this.props.placeholder }
                        onChange={ e => this.setState({ q: e.target.value }) }
                        defaultValue={ this.props.defaultValue }
                    />
                    <span className="input-group-btn">
                        {
                            this.state.q !== "" && (
                                <button type="button" className="btn btn-default" onClick={ this._clearSearch }>
                                    <i className="fa fa-remove" />
                                </button>
                            )
                        }
                        <button type="submit" className="btn btn-primary">
                            <i className="fa fa-search" />
                        </button>
                    </span>
                </div>
            </form>
        );
    }

    _clearSearch(e) {
        e.preventDefault();
        Turbolinks.visit(this.props.target(""));
    }

    _onSubmit(e) {
        e.preventDefault();
        Turbolinks.visit(this.props.target(this.state.q));
    }

}

export default EuiSearchBox;
